import gql from "graphql-tag";

const workTimeSeasonMutations = {


    createWorkTimeSeason: gql`
        mutation CreateWorkTimeSeason($season: String, $month: String) {
            createWorkTimeSeason(season: $season, month: $month) {
                id,
                season,
                month
            }
        }
    `,
    updateWorkTimeSeason: gql`
        mutation UpdateWorkTimeSeason($id: ID!, $season: String, $month: String) {
            updateWorkTimeSeason(id: $id, season: $season, month: $month) {
                id,
                season,
                month
            }
        }
    `,
};

export default workTimeSeasonMutations;